export default class CustomerSearchRequest {
  public email: string;

  constructor(options) {
    this.email = options.email;
  }
}
